import React, { useState } from 'react';
import loginimage from "../../assets/Login_img.jpg";
import CardMedia from '@mui/material/CardMedia';
import Button from "../../components/Button";
import Login from './Login';
import SignUp from './SignUp';
import {
  Grid,
} from "@mui/material";
const LoginSignup = ({ handleLogin }) => {
  
  const [show, setShow] = useState(true);
  const handleClick = num => {
    setShow(num);
  };

  return (
    <Grid sx={{ display: 'flex', width: '100%' }}>
      <Grid sx={{ width: '40%', position: 'fixed' }}>
        <CardMedia sx={{ height: '100vh' }}
          component="img"
          image={loginimage}
          alt="green iguana"
        />
      </Grid>
      <Grid style={{ width: '60%', marginLeft: '53%', }}>
        {show ? (<Login handleClick={handleClick} handleLogin={handleLogin} />) : (<SignUp handleClick={handleClick} handleLogin={handleLogin} />)}
      </Grid>
    </Grid>

  );
}

export default LoginSignup;